import { computed, ComputedRef } from 'vue'
import { useStore } from 'vuex'

import { ModelAnswerPageStateModuleName } from '@/store/modules/modules'

export class ModelAnswerPageStateViewModel {
  private store = useStore()

  modelAnswerExpandedList: ComputedRef<{ [judgeId: number]: boolean }> = computed(
    () => this.store.getters[`${ModelAnswerPageStateModuleName}/modelAnswerExpandedList`]
  )
  modelAnswerLoadingList: ComputedRef<{ [judgeId: number]: boolean }> = computed(
    () => this.store.getters[`${ModelAnswerPageStateModuleName}/modelAnswerLoadingList`]
  )
  modelAnswerIsDiffList: ComputedRef<{ [judgeId: number]: boolean }> = computed(
    () => this.store.getters[`${ModelAnswerPageStateModuleName}/modelAnswerIsDiffList`]
  )
  pageIndex: ComputedRef<number> = computed(() => this.store.getters[`${ModelAnswerPageStateModuleName}/pageIndex`])
  isFirstOpendPage: ComputedRef<boolean> = computed(
    () => this.store.getters[`${ModelAnswerPageStateModuleName}/isFirstOpendPage`]
  )
  isNotMoreModelAnswerList: ComputedRef<boolean> = computed(
    () => this.store.getters[`${ModelAnswerPageStateModuleName}/isNotMoreModelAnswerList`]
  )

  setPageIndex(pageIndex: number): void {
    this.store.commit(`${ModelAnswerPageStateModuleName}/setPageIndex`, { pageIndex })
  }

  setIsFirstOpendPage(flag: boolean): void {
    this.store.commit(`${ModelAnswerPageStateModuleName}/setIsFirstOpendPage`, { flag })
  }

  setIsNotMoreModelAnswerList(flag: boolean): void {
    this.store.commit(`${ModelAnswerPageStateModuleName}/setIsNotMoreModelAnswerList`, { flag })
  }

  setModelAnswerExpandedList(list: { [judgeId: number]: boolean }): void {
    this.store.commit(`${ModelAnswerPageStateModuleName}/setModelAnswerExpandedList`, { list })
  }

  setModelAnswerExpandedFlag(judgeId: number, flag: boolean): void {
    this.store.commit(`${ModelAnswerPageStateModuleName}/setModelAnswerExpandedFlag`, { judgeId, flag })
  }

  setModelAnswerLoadingList(list: { [judgeId: number]: boolean }): void {
    this.store.commit(`${ModelAnswerPageStateModuleName}/setModelAnswerLoadingList`, { list })
  }

  setModelAnswerLoadingFlag(judgeId: number, flag: boolean): void {
    this.store.commit(`${ModelAnswerPageStateModuleName}/setModelAnswerLoadingFlag`, { judgeId, flag })
  }

  setModelAnswerIsDiffList(list: { [judgeId: number]: boolean }): void {
    this.store.commit(`${ModelAnswerPageStateModuleName}/setModelAnswerIsDiffList`, { list })
  }

  setModelAnswerIsDiffFlag(judgeId: number, flag: boolean): void {
    this.store.commit(`${ModelAnswerPageStateModuleName}/setModelAnswerIsDiffFlag`, { judgeId, flag })
  }
}
